// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"aa5abe56","440":"23adbe6e","815":"cb0b7040"}[chunkId] + ".chunk.js";
};